<div *ngIf="SelectedStudent">
    <h2>
        Current Student Information<span *ngIf="SelectedStudent?.IsPastDemo">
            <em>({{ SelectedStudent?.SchoolYear | schoolYear }} - Last year available)</em></span
        >
    </h2>
    <div *ngIf="SelectedStudent" fxLayout="row" fxLayout.lt-md="column">
        <div *ngIf="SelectedStudent" fxLayout="column" fxFlex="50" fxFlex.lt-md="100">
            <div>
                <strong>Student Name: </strong>{{ SelectedStudent.FirstName | titleCase }}
                {{ SelectedStudent.MiddleName | titleCase }} {{ SelectedStudent.LastName | titleCase }}
            </div>
            <div><strong>Student ID: </strong>{{ SelectedStudent.StudentID }}</div>
            <div><strong>SSN: </strong>{{ SelectedStudent.SSN | socialSecurity }}</div>
            <div>
                <strong>Date of Birth: </strong>{{ SelectedStudent.BirthDate | datefns: 'M/DD/YYYY' }} (Age
                {{ SelectedStudent.BirthDate | age }})
            </div>
            <div><strong>School: </strong>{{ SelectedStudent.SchoolName }}</div>
            <div><strong>Grade: </strong>{{ SelectedStudent.GradeLevel }}</div>
            <div><strong>Unweighted GPA: </strong>{{ SelectedStudent.GPA}}</div>
            <div class="displaimer">
                <strong>Unweighted College GPA: </strong>{{ SelectedStudent.CollegeGPA || '-' }}
                <span class="mat-icon"><strong>†</strong></span>
            </div>
            <div>
                <strong>Student Email: </strong>
                <span *ngIf="SelectedStudent.StudentEmail">
                    <a [href]="'mailto:' + SelectedStudent.StudentEmail">{{ SelectedStudent.StudentEmail }}</a>
                </span>
                <span *ngIf="!SelectedStudent.StudentEmail">N/A</span>
            </div>
            <div>
                <strong>Student Phone: </strong>
                {{ (SelectedStudent.StudentPhone | phone: 'parensdash') || 'N/A' }}
            </div>
        </div>
        <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100">
            <div fxLayout="row" fxLayoutAlign="start center" *ngIf="SelectedCollege">
                <strong style="margin-right: 15px"
                    ><span>{{ (SelectedCollege.CollegeID | CollegeAbbreviation) + ' ' }}</span
                    >College ID:
                </strong>
                <div *ngIf="SelectedCollege && !SelectedCollege.StudentCollegeID">None Provided</div>
                <div *ngIf="SelectedCollege && SelectedCollege.StudentCollegeID">{{ SelectedCollege.StudentCollegeID }}</div>
                <button
                    class="margin-left"
                    *ngIf="
                        User &&
                        (!User.IsStudent && !User.IsParent) &&
                        SelectedCollege
                    "
                    mat-raised-button
                    [color]="SelectedCollege.StudentCollegeID ? 'primary' : 'accent'"
                    (click)="UpdateCollegeStudentID()"
                >
                    Update
                </button>
            </div>
            <div fxLayout="row">
                <strong style="margin-right: 15px">Residence Address: </strong>
                <div fxLayout="column">
                    <div>{{ SelectedStudent.Address }}</div>
                    <div *ngIf="SelectedStudent.Apartment">{{ SelectedStudent.Apartment }}</div>
                    <div>{{ SelectedStudent.City }}, {{ SelectedStudent.State }} {{ SelectedStudent.Zip | zipcode }}</div>
                </div>
            </div>
            <div fxLayout="row" *ngIf="SelectedStudent?.MailingAddress">
                <strong style="margin-right: 15px">Mailing Address: </strong>
                <div fxLayout="column">
                    <div>{{ SelectedStudent.MailingAddress }}</div>
                    <div *ngIf="SelectedStudent.MailingApartment">{{ SelectedStudent.MailingApartment }}</div>
                    <div>
                        {{ SelectedStudent.MailingCity }}, {{ SelectedStudent.MailingState }}
                        {{ SelectedStudent.MailingZip | zipcode }}
                    </div>
                </div>
            </div>
            <div><strong>Phone: </strong>{{ SelectedStudent.HomePhone | phone: 'parensdash' }}</div>
            <div>
                <strong>Parent Name: </strong>{{ SelectedStudent.ParentFirstName | titleCase }}
                {{ SelectedStudent.ParentLastName | titleCase }}
            </div>
            <div><strong>Parent Email: </strong>{{ SelectedStudent.ParentEmail }}</div>
            <div><strong>Parent Phone: </strong>{{ SelectedStudent.ParentPhone | phone: 'parensdash' }}</div>
        </div>
    </div>
    <p class="displaimer" style="align-items: start; margin-top: 10px; margin-bottom: 10px;">
        <span class="mat-icon"><strong>†</strong></span>
        <em>{{ CollegeGPADisclaimer }} <a style="text-decoration:underline; color: #009688; font-size: medium; cursor: pointer;" (click)="OpenGPADisclaimerDialog()"> See more information here.</a></em>
    </p>
</div>



// WEBPACK FOOTER //
// ./src/app/ui/studentinfo/studentinfo.component.html